import { VideoTimeline } from '../../../../API/types/Videos';
import { TimeRangeMs } from '../../../../utils/videoFulfillmentUtils';

export const dateValidation = /^(0[1-9]|[1-2][0-9]|3[0-1])\/(0[1-9]|1[0-2])\/(\d{4})$/;
export const timeValidation = /^(2[0-3]|[01][0-9]):([0-5][0-9])(:[0-5][0-9])?$/;
export const durationValidation = /^(0*[1-9][0-9]*)$/;

type TimelineType = Array<{ start: number; end: number }>;

export type Lookup = {
  [key: string]: TimelineType
};
export const getTimeRanges = (timelines: VideoTimeline): Lookup => timelines
  ?.timeRange
  ?.reduce((acc: Lookup, { cameraId, tsSecEpochStart, tsSecEpochEnd }) => {
    if (acc[cameraId]) {
      acc[cameraId].push({ start: tsSecEpochStart * 1000, end: tsSecEpochEnd * 1000 });
    } else {
      acc[cameraId] = [{ start: tsSecEpochStart * 1000, end: tsSecEpochEnd * 1000 }];
    }
    return acc;
  }, {}) || {};
// export const getTimeRangesById = (timeRanges: Lookup, id: string): TimeRangeMs[] => timeRanges[id]
//   ?.map(({ start, end }) => [start, end]) || [];
export const getTimeRangesById = (timeRanges: Lookup, id: string): TimeRangeMs[] => {
  if (id === '0') {
    const timeRange1 = timeRanges['1']?.map(({ start, end }): TimeRangeMs => [start, end]) || [];
    const timeRange2 = timeRanges['2']?.map(({ start, end }): TimeRangeMs => [start, end]) || [];
    if (timeRange1.length && timeRange2.length) {
      return timeRange1;
    }
  }
  return timeRanges[id]?.map(({ start, end }): TimeRangeMs => [start, end]) || [];
};
export const parseDateFromString = (date: string): { day: string; month: string; year: string } => {
  const [day, month, year] = date.split('/');
  return {
    day, month, year,
  };
};

export const generateDateFromString = (date: string, currentTime: string): string => {
  const { day, month, year } = parseDateFromString(date);
  return new Date(`${year}-${month}-${day}T${currentTime}`).toISOString();
};

export const parseToDateString = (date: Date): string => (
  date.toLocaleDateString('en-GB')
);

export const parseToDateTimeString = (date: Date, withSecconds?: boolean): string => (
  date.toLocaleTimeString('en-GB', {
    hour: '2-digit', minute: '2-digit', second: withSecconds ? '2-digit' : undefined,
  })
);

export const formatNoFootageAvailableError = (ranges: TimeRangeMs[]): string => {
  const rangeLines = ranges.map(([start, end]) => {
    const from = parseToDateTimeString(new Date(start), true);
    const to = parseToDateTimeString(new Date(end), true);
    return `• ${from} – ${to}`;
  });

  return [
    'No footage available for the selected time.',
    'Available ranges:',
    ...rangeLines,
  ].join('\n');
};

export const hasValidTimeInterval = (start: number, end: number, timeInMs = 5400000): boolean => {
  if (start && end) {
    return end - start >= timeInMs;
  }
  return true;
};
